import React, { Fragment, useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import ModalComponent from "../Components/Workshop/ModalComponent";
import { useGetEventListQuery } from "../Store/api/EventListApi";
import EventComponent from "../Components/Workshop/EventComponent";
import { useGetPageDataQuery } from "../Store/api/CommonApi";

export default function Workshop() {
  const [upcoming, setUpcoming] = useState([]);
  const [past, setPast] = useState([]);
  const [event, setEvent] = useState(null);
  const [eventType, setEventType] = useState("");
  const { data, isError } = useGetEventListQuery();
  const [path, setPath] = useState("");

  const pageApi = useGetPageDataQuery("workshop-events");

  useEffect(() => {
    window.$(".nav-tabs").tab();
  }, []);

  const onShowModal = useCallback((event, type) => {
    setEvent(event);
    setEventType(type);
    window.$("#signup").modal("show");
  }, []);

  useEffect(() => {
    setUpcoming(data?.data?.upcomingEvent);
    setPast(data?.data?.pastEvent);
    setPath(data?.data?.path);
  }, [data]);

  useEffect(() => {
    if (isError) {
      Swal.fire({
        title: "Error!",
        text: "Error while feching events.",
        icon: "error",
      });
    }
  }, [isError]);

  return (
    <Fragment>
      <PageBannerComponent
        title={pageApi.data?.data?.heading}
        image={pageApi.data?.data?.image}
      />

      {/* {pageApi.data?.data?.content !== "" && (
        <div className="container mt-4">
          <p
            dangerouslySetInnerHTML={{ __html: pageApi.data?.data?.content }}
          ></p>
        </div>
      )} */}

      <div className="row d-flex pt-5 justify-content-center text-center">
        <div className="col-md-10 pb-40 header-text">
          <h1 className="mb-4">Learn. Grow. Thrive.</h1>
          <p>
            Join our dynamic workshops and events—virtual or in-person in your
            city—and take your career to new heights!
            <br />
            Gain valuable skills, update your expertise, and master in-demand
            skill sets. <br />
            Connect with industry leaders, expand your professional network, and
            thrive within a supportive community. <br />
            Explore exclusive opportunities designed for the LGBT+ community,
            where your identity is celebrated, and your talents are truly
            valued. <br />
            <br />
            <strong>
              Designed exclusively for the LGBT+ community—because your career
              deserves to shine!
            </strong>
          </p>
        </div>
      </div>

      {/* Start service Area */}
      <section className="service-area section-gap pt-5" id="service">
        <div className="container">
          <div className="tab tool-tab" role="tabpanel">
            {/* Nav tabs */}
            <ul className="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  href="#Section1"
                  role="tab"
                  data-toggle="tab"
                  className="active"
                >
                  <i className="fa fa-envelope-o" />
                  Upcoming Events
                </a>
              </li>
              <li role="presentation">
                <a href="#Section2" role="tab" data-toggle="tab">
                  <i className="fa fa-cube" />
                  Past Events
                </a>
              </li>
            </ul>
            {/* Tab panes */}
            <div className="tab-content tabs" id="home">
              <div role="tabpanel" className="tab-pane active" id="Section1">
                <div className="row">
                  {upcoming?.length > 0 ? (
                    upcoming.map((event, i) => (
                      <EventComponent
                        event={event}
                        key={i}
                        path={path}
                        type="upcoming"
                        onShowModal={onShowModal}
                      />
                    ))
                  ) : (
                    <h6 className="col text-center">No upcoming event found</h6>
                  )}
                </div>
              </div>
              <div role="tabpanel" className="tab-pane fade" id="Section2">
                <div className="row">
                  {past?.length > 0 ? (
                    past.map((event, i) => (
                      <EventComponent
                        event={event}
                        key={i}
                        path={path}
                        type="past"
                        onShowModal={onShowModal}
                      />
                    ))
                  ) : (
                    <h6 className="col text-center">No past event found</h6>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End service Area */}
      <ModalComponent event={event} eventType={eventType} />
    </Fragment>
  );
}
